<template>
    <!-- 弹框组件 -->
    <div class="vel-modal">
        <!-- 对话框 -->
        <el-dialog
        v-if="!drawer"
        :visible.sync="visible"
        :title="title"
        :width="width"
        :fullscreen="fullscreen"
        :top="top"
        :modal="modal"
        :modal-append-to-body="modalInBoday"
        :append-to-body="appendBody"
        :lock-scroll="lockSroll"
        :custom-class="modalClass"
        :close-on-click-modal="closeClickModal"
        :close-on-press-escape="closeEscModal"
        :show-close="showClose"
        :before-close="beforeCloseFn"
        :center="center"
        :destroy-on-close="destroyClose"
        @open="open"
        @opened="opened"
        @close="close"
        @closed="closed"
        >   
            <!-- title插槽 -->
            <template #title>
                <span class="vel-modal-title">
                    <VelIcon :iconName="titleIcon" :type="iconType" />
                    {{title}}
                </span>
            </template>
            <!-- 内容插槽 -->
            <slot></slot>
            <!-- 底部插槽 -->
            <span slot="footer">
                <slot name="footer">
                    <template v-for="(ac,acinx) in actionList">
                        <VelBtn
                        v-if="showAction.includes(ac.key)"
                        :type="ac.key==='cancel'?'':'primary'"
                        :btnText="ac.text" 
                        :key="ac.key + acinx"
                        @btnClick="actionFn(ac.key)"
                        />
                    </template>
                </slot>
            </span>
        </el-dialog>
        <!-- 抽屉 -->
        <el-drawer
        v-else
        :visible.sync="visible"
        :title="title"
        :size="width"
        :modal="modal"
        :direction="direction"
        :modal-append-to-body="modalInBoday"
        :append-to-body="appendBody"
        :custom-class="modalClass"
        :wrapperClosable="closeClickModal"
        :close-on-press-escape="closeEscModal"
        :show-close="showClose"
        :before-close="beforeCloseFn"
        :destroy-on-close="destroyClose"
        :withHeader="withHeader"
        @open="open"
        @opened="opened"
        @close="close"
        @closed="closed"
        >
            <!-- title插槽 -->
            <template #title>
                <span class="vel-modal-title">
                    <VelIcon :iconName="titleIcon" :type="iconType" />
                    {{title}}
                </span>
            </template>
            <!-- 内容插槽 -->
            <slot></slot>
        </el-drawer>
    </div>
</template>
<script>
import VelBtn from '../button'
import VelIcon from '../icon'
export default {
    inheritAttrs: true,
    name:"VelModal",
    components:{
        VelBtn,
        VelIcon
    },
    props: {
        width:[String,Number],
        modalClass:String,
        top:String,
        direction:String,
        beforeCloseFn:Function,
        isFullscreen:Boolean,
        isModal:Boolean,
        isModalInBoday:Boolean,
        isAppendBody:Boolean,
        isLockSroll:Boolean,
        isCloseEscModal:Boolean,
        isShowClose:Boolean,
        isCenter:Boolean,
        isDestroyClose:Boolean,
        isCloseClickModal:Boolean,
        isWithHeader:Boolean,
        isDrawer:Boolean,
        titleIcon:{
            type:String,
            default:'el-icon-info'
        },
        iconType:{
            type:String,
            default:'primary'
        },
        mdlVisible:{
            type:Boolean,
            required:true, 
            default:false,
        },
        title:{
            type:String,
            default:'弹框'
        },
        showAction:{
            type:[Array,String],
            default:() =>{
                return ['cancel','confirm']
            }
        },
        actionList:{
            type:Array,
            default:() =>{
                return [
                    {key:'cancel',text:'取消'},
                    {key:'confirm',text:'确定'},
                ]
            }
        }
    },
    computed:{
        visible:{
            get(){
                return this.mdlVisible
            },
            set(val){
                this.$emit('update:mdlVisible',val)
            }
        }
    },
    data() {
        return {
            fullscreen:false,
            modal:true,
            modalInBoday:true,
            appendBody:false,
            lockSroll:true,
            closeClickModal:true,
            closeEscModal:true,
            showClose:true,
            center:false,
            destroyClose:false,
            withHeader:true,
            drawer:false,
        };
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isFullscreen ? this.fullscreen = true : this.fullscreen
            this.isModal ? this.modal = false : this.modal
            this.isModalInBoday ? this.modalInBoday = false : this.modalInBoday
            this.isAppendBody ? this.appendBody = true : this.appendBody
            this.isLockSroll ? this.lockSroll = false : this.lockSroll
            this.isCloseEscModal ? this.closeEscModal = false : this.closeEscModal
            this.isShowClose ? this.showClose = false : this.showClose
            this.isCenter ? this.center = true : this.center
            this.isDestroyClose ? this.destroyClose = true : this.destroyClose
            this.isCloseClickModal ? this.closeClickModal = false : this.closeClickModal
            this.isWithHeader ? this.withHeader = false : this.withHeader
            this.isDrawer ? this.drawer = true : this.drawer
        },
        actionFn(type){
            this.$emit('actionFn',type)
        },
        close(){
            this.$emit("close");
        },
        closed() {
            this.$emit("closed");
        },
        open() {
            this.$emit("open");
        },
        opened() {
            this.$emit("opened");
        },
    }
};
</script>
<style scoped>
.vel-modal-title{
    font-size: 17px;
}
</style>